export default "__VITE_ASSET__Bk4uodXE__"